import React from 'react';
import PropTypes from 'prop-types';

// Utils
import { useRouter } from 'next/router';

// Icons
import BackIcon from '../../../public/icons/arrow.svg';

import styles from './PreviousButton.module.scss';

function PreviousButton({ children, refButton, className }) {
  const router = useRouter();

  return (
    <button
      type="button"
      ref={refButton}
      className={`${styles.back_prev} ${className} ws-nowrap`}
      onClick={() => router.back()}
    >
      <span className={styles.prev_icon}>
        <BackIcon />
      </span>
      <span>{children}</span>
    </button>
  );
}

PreviousButton.propTypes = {
  children: PropTypes.node,
};

PreviousButton.defaultProps = {
  children: null,
};

export default PreviousButton;
